export function generateOTPForSMS(send) {
  return (tokenId, ...args) =>
    send(
      {
        path: '/v1/tokens/{tokenId}/otp/generate',
        pathParameters: { tokenId },
        type: 'post',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
